import React from "react";

import { useField } from "formik";

import { SxProps, Theme } from "@mui/material";
import { red } from "@mui/material/colors";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";
import { Stack } from "@mui/system";

export interface FormikRadioGroupItem {
  value: string;
  title: string;
}

type FormikRadioGroupProps = {
  name: string;
  label?: string;
  sxRadioGroup?: SxProps<Theme>;
  sxRadio?: SxProps<Theme>;
  radioList: FormikRadioGroupItem[];
} & RadioGroupProps;
export const FormikRadioGroup = ({
  name,
  label,
  sxRadioGroup,
  sxRadio,
  radioList,
  ...props
}: FormikRadioGroupProps) => {
  const [
    field,
    meta,
    // helpers
  ] = useField(name);

  return (
    <FormControl>
      {label && (
        <Stack marginBottom={1}>
          <FormLabel
            sx={{ color: "#666666 !important" }}
            id={`formlabel-${name}`}
          >
            {label}
          </FormLabel>
        </Stack>
      )}

      <React.Fragment>
        <RadioGroup {...field} {...props} name={field.name} sx={sxRadioGroup}>
          <Stack spacing={2}>
            {radioList.map((item) => (
              <FormControlLabel
                key={item.value}
                value={item.value}
                control={<Radio />}
                label={item.title}
                sx={sxRadio}
              />
            ))}
          </Stack>
        </RadioGroup>

        {meta.touched && Boolean(meta.error) && (
          <FormHelperText sx={{ color: red[700] }}>{meta.error}</FormHelperText>
        )}
      </React.Fragment>
    </FormControl>
  );
};
